'use client'

import {
  Button,
  FormControl,
  Flex,
  Heading,
  Input,
  Stack,
  Text,
  useColorModeValue,
  useToast,
} from '@chakra-ui/react'
import { useAction } from 'next-safe-action/hook'
import { useState } from 'react'
import { forgotPassword } from './actions'

export default function ForgotPasswordForm() {
  const [email, setEmail] = useState<string>('')
  const toast = useToast()

  const { execute, status } = useAction(forgotPassword, {
      onSuccess: (data) => {
          // console.log(data);

          if (data?.failure) {
              toast({
                  title: 'Une erreur est survenue!',
                  description: data?.failure.toString(),
                  status: 'error',
                  isClosable: true,
                  position: 'top'
              })
          } else {
              toast({
                  title: 'Opération réussie!',
                  description: data?.success.toString(),
                  status: 'success',
                  variant: 'top-accent',
                  isClosable: true,
                  position: 'top',
                  duration: null
              })

              setEmail('')
          }
      },
      onError: (error) => {
          // console.log("Une erreur: ", error);

          toast({
              title: 'Error',
              description: 'Veuillez vérifier vos paramètres',
              status: 'error',
              isClosable: true,
              position: 'top'
          })
      }
  });
  async function handleSubmit() {
    execute({email})
  }
  return (
    <Flex
      minH={'100vh'}
      align={'center'}
      justify={'center'}
      bg={useColorModeValue('gray.100', 'gray.800')}>
      <Stack
        spacing={4}
        w={'full'}
        maxW={'md'}
        bg={useColorModeValue('white', 'gray.700')}
        rounded={'xl'}
        boxShadow={'lg'}
        p={6}
        my={12}>
        <Heading lineHeight={1.1} fontSize={{ base: '2xl', md: '3xl' }}>
          Mot de passe oublié?
        </Heading>
        <Text
          fontSize={{ base: 'sm', sm: 'md' }}
          color={useColorModeValue('gray.800', 'gray.400')}>
          Vous recevrez un mail avec le lien de réinitialisation
        </Text>
        <FormControl id="email" isRequired>
          <Input
            placeholder="your-email@example.com"
            _placeholder={{ color: 'gray.500' }}
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </FormControl>
        <Stack spacing={6}>
          <Button
            colorScheme='brand'
            onClick={handleSubmit}
            isLoading={status && status === "executing"}
          >
            Envoyer
          </Button>
        </Stack>
      </Stack>
    </Flex>
  )
}